import { createPortal } from 'react-dom';

function GoogleReactPortal({ children, wrapperId, openModal }) {
  if (!document.getElementById(wrapperId)) {
    return null;
  }

  if (
    !(
      document.getElementById('portal-modal')?.getAttribute('openmodal') ===
      'true'
    )
  ) {
    document
      .getElementById('portal-modal')
      .setAttribute('openmodal', openModal);
  }
  return createPortal(children, document.getElementById(wrapperId));
}
export default GoogleReactPortal;
